<div class="list">
    <div class="line" *ngFor="let width of [1,2,3,4]">
        <ion-skeleton-text animated [ngStyle]="{width: '70%'}"></ion-skeleton-text>
        <ion-skeleton-text animated [ngStyle]="{width: '50%'}"></ion-skeleton-text>
        <ion-skeleton-text animated [ngStyle]="{width: '20%'}"></ion-skeleton-text>
    </div>
</div>
